// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/CygnitoMono.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/CygnitoMono.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/bg-left.svg?background", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/bg-right.svg?background", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Geist:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css *//* Document
   ========================================================================== *//**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}/* Sections
   ========================================================================== *//**
 * Remove the margin in all browsers.
 */body {
  margin: 0;
}/**
 * Render the \`main\` element consistently in IE.
 */main {
  display: block;
}/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */h1 {
  font-size: 2em;
  margin: 0.67em 0;
}/* Grouping content
   ========================================================================== *//**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}/* Text-level semantics
   ========================================================================== *//**
 * Remove the gray background on active links in IE 10.
 */a {
  background-color: transparent;
}/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline;
  -webkit-text-decoration: underline dotted currentColor;
          text-decoration: underline dotted currentColor; /* 2 */
}/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */b,
strong {
  font-weight: bolder;
}/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}/**
 * Add the correct font size in all browsers.
 */small {
  font-size: 80%;
}/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}sub {
  bottom: -0.25em;
}sup {
  top: -0.5em;
}/* Embedded content
   ========================================================================== *//**
 * Remove the border on images inside links in IE 10.
 */img {
  border-style: none;
}/* Forms
   ========================================================================== *//**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */button,
input { /* 1 */
  overflow: visible;
}/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */button,
select { /* 1 */
  text-transform: none;
}/**
 * Correct the inability to style clickable types in iOS and Safari.
 */button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}/**
 * Remove the inner border and padding in Firefox.
 */button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}/**
 * Restore the focus styles unset by the previous rule.
 */button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}/**
 * Correct the padding in Firefox.
 */fieldset {
  padding: 0.35em 0.75em 0.625em;
}/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */progress {
  vertical-align: baseline;
}/**
 * Remove the default vertical scrollbar in IE 10+.
 */textarea {
  overflow: auto;
}/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}/* Interactive
   ========================================================================== *//*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */details {
  display: block;
}/*
 * Add the correct display in all browsers.
 */summary {
  display: list-item;
}/* Misc
   ========================================================================== *//**
 * Add the correct display in IE 10+.
 */template {
  display: none;
}/**
 * Add the correct display in IE 10.
 */[hidden] {
  display: none;
}@font-face {
	font-family: 'Cygnito Mono';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
	font-style: normal;
	font-weight: normal;
	font-display: block;
}:root {
	--black: #000;
	--white: #fff;
	--brand: #0f0;
	--gray: #f3f3f3;
	--gray2: #dfdfdf;
	--gray3: #666;
	--green: #38a126;

	--main-width: 700px;
	--main-padding-horizontal: 50px;
}*,
*:before,
*:after {
	box-sizing: border-box;
}html,
body {
	height: 100%;
}body {
	font-family: 'Cygnito Mono', monospace;
	/* Growth month theme */
	background-color: #f3f3f3;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}a {
	text-decoration: none;
}button {
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	cursor: pointer;
}#application {
	display: flex;
	flex-direction: column;
	min-width: 330px;
	min-height: 100vh;
	height: 100%;
	margin: 0 auto;
	padding: 0 0 28px;
	overflow-y: auto;
}@media (max-width: 767px) {#application {
		width: 100%;
		padding: 0;
}
	}#application {

	background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat fixed left bottom,
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat fixed right bottom;
	background-size: min(400px, 25%) auto, min(400px, 25%) auto;
}
`, "",{"version":3,"sources":["webpack://./node_modules/normalize.css/normalize.css","webpack://./src/stylesheets/fonts.pcss","webpack://./src/stylesheets/variables.pcss","webpack://./src/index.pcss"],"names":[],"mappings":"AAAA,2EAA2E,CAE3E;+EAC+E,CAE/E;;;EAGE,CAEF;EACE,iBAAiB,EAAE,MAAM;EACzB,8BAA8B,EAAE,MAAM;AACxC,CAEA;+EAC+E,CAE/E;;EAEE,CAEF;EACE,SAAS;AACX,CAEA;;EAEE,CAEF;EACE,cAAc;AAChB,CAEA;;;EAGE,CAEF;EACE,cAAc;EACd,gBAAgB;AAClB,CAEA;+EAC+E,CAE/E;;;EAGE,CAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,SAAS,EAAE,MAAM;EACjB,iBAAiB,EAAE,MAAM;AAC3B,CAEA;;;EAGE,CAEF;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB,CAEA;+EAC+E,CAE/E;;EAEE,CAEF;EACE,6BAA6B;AAC/B,CAEA;;;EAGE,CAEF;EACE,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;EAClC,0BAAiC;EAAjC,sDAAiC;UAAjC,8CAAiC,EAAE,MAAM;AAC3C,CAEA;;EAEE,CAEF;;EAEE,mBAAmB;AACrB,CAEA;;;EAGE,CAEF;;;EAGE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB,CAEA;;EAEE,CAEF;EACE,cAAc;AAChB,CAEA;;;EAGE,CAEF;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B,CAEA;EACE,eAAe;AACjB,CAEA;EACE,WAAW;AACb,CAEA;+EAC+E,CAE/E;;EAEE,CAEF;EACE,kBAAkB;AACpB,CAEA;+EAC+E,CAE/E;;;EAGE,CAEF;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,eAAe,EAAE,MAAM;EACvB,iBAAiB,EAAE,MAAM;EACzB,SAAS,EAAE,MAAM;AACnB,CAEA;;;EAGE,CAEF;QACQ,MAAM;EACZ,iBAAiB;AACnB,CAEA;;;EAGE,CAEF;SACS,MAAM;EACb,oBAAoB;AACtB,CAEA;;EAEE,CAEF;;;;EAIE,0BAA0B;AAC5B,CAEA;;EAEE,CAEF;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ,CAEA;;EAEE,CAEF;;;;EAIE,8BAA8B;AAChC,CAEA;;EAEE,CAEF;EACE,8BAA8B;AAChC,CAEA;;;;;EAKE,CAEF;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;EACtB,cAAc,EAAE,MAAM;EACtB,eAAe,EAAE,MAAM;EACvB,UAAU,EAAE,MAAM;EAClB,mBAAmB,EAAE,MAAM;AAC7B,CAEA;;EAEE,CAEF;EACE,wBAAwB;AAC1B,CAEA;;EAEE,CAEF;EACE,cAAc;AAChB,CAEA;;;EAGE,CAEF;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,UAAU,EAAE,MAAM;AACpB,CAEA;;EAEE,CAEF;;EAEE,YAAY;AACd,CAEA;;;EAGE,CAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B,CAEA;;EAEE,CAEF;EACE,wBAAwB;AAC1B,CAEA;;;EAGE,CAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB,CAEA;+EAC+E,CAE/E;;EAEE,CAEF;EACE,cAAc;AAChB,CAEA;;EAEE,CAEF;EACE,kBAAkB;AACpB,CAEA;+EAC+E,CAE/E;;EAEE,CAEF;EACE,aAAa;AACf,CAEA;;EAEE,CAEF;EACE,aAAa;AACf,CC1VA;CACC,2BAA2B;CAC3B;wDACoD;CACpD,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;AACpB,CCTA;CACC,aAAa;CACb,aAAa;CACb,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,gBAAgB;;CAEhB,mBAAmB;CACnB,+BAA+B;AAChC,CCLA;;;CAGC,sBAAsB;AACvB,CAEA;;CAEC,YAAY;AACb,CAEA;CACC,sCAAsC;CACtC,uBAAuB;CACvB,yBAAyB;CACzB,mCAAmC;CACnC,kCAAkC;AACnC,CAEA;CACC,qBAAqB;AACtB,CAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,SAAS;CACT,aAAa;CACb,cAAc;CACd,eAAe;AAChB,CAEA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,gBAAgB;AAUjB,CARC,2BAVD;EAWE,WAAW;EACX,UAAU;AAMZ;CALC,CAbD;;CAeC;sEAC4E;CAC5E,2DAA2D;AAC5D","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Render the `main` element consistently in IE.\n */\n\nmain {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the gray background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n","@import url('https://fonts.googleapis.com/css2?family=Geist:wght@400;500&display=swap');\n\n@font-face {\n\tfont-family: 'Cygnito Mono';\n\tsrc: url('assets/fonts/CygnitoMono.woff2') format('woff2'),\n\t\turl('assets/fonts/CygnitoMono.woff') format('woff');\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-display: block;\n}\n",":root {\n\t--black: #000;\n\t--white: #fff;\n\t--brand: #0f0;\n\t--gray: #f3f3f3;\n\t--gray2: #dfdfdf;\n\t--gray3: #666;\n\t--green: #38a126;\n\n\t--main-width: 700px;\n\t--main-padding-horizontal: 50px;\n}\n","@import 'normalize.css';\n\n@import './stylesheets/fonts.pcss';\n@import './stylesheets/variables.pcss';\n@import './stylesheets/media-queries.pcss';\n\n*,\n*:before,\n*:after {\n\tbox-sizing: border-box;\n}\n\nhtml,\nbody {\n\theight: 100%;\n}\n\nbody {\n\tfont-family: 'Cygnito Mono', monospace;\n\t/* Growth month theme */\n\tbackground-color: #f3f3f3;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\na {\n\ttext-decoration: none;\n}\n\nbutton {\n\tbackground: none;\n\tborder: none;\n\tpadding: 0;\n\tmargin: 0;\n\tfont: inherit;\n\tcolor: inherit;\n\tcursor: pointer;\n}\n\n:global(#application) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 330px;\n\tmin-height: 100vh;\n\theight: 100%;\n\tmargin: 0 auto;\n\tpadding: 0 0 28px;\n\toverflow-y: auto;\n\n\t@media (--mobile) {\n\t\twidth: 100%;\n\t\tpadding: 0;\n\t}\n\n\tbackground: url('./assets/images/bg-left.svg?background') no-repeat fixed left bottom,\n\t\turl('./assets/images/bg-right.svg?background') no-repeat fixed right bottom;\n\tbackground-size: min(400px, 25%) auto, min(400px, 25%) auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"application": `application`
};
export default ___CSS_LOADER_EXPORT___;
